import { useEffect, useState } from "react";
import { getBilling } from "@piiqtechnologies/ui-lib";
import { BILLING_STATUS } from "@constants/BillingStatus";
const enterpriseByOrg = new Map();
const inflightByOrg = new Map();
const resolveIsEnterprise = (organizationId) => {
    const inflight = inflightByOrg.get(organizationId);
    if (inflight)
        return inflight;
    const request = getBilling(organizationId)
        .then((response) => { var _a, _b; return ((_b = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.billing) === null || _b === void 0 ? void 0 : _b.status) === BILLING_STATUS.ENTERPRISE_INVOICED; })
        .catch(() => false)
        .then((result) => {
        enterpriseByOrg.set(organizationId, result);
        inflightByOrg.delete(organizationId);
        return result;
    });
    inflightByOrg.set(organizationId, request);
    return request;
};
export const clearEnterpriseCache = () => {
    enterpriseByOrg.clear();
    inflightByOrg.clear();
};
export const useIsEnterprise = (organizationId, enabled) => {
    const [isEnterprise, setIsEnterprise] = useState(() => { var _a; return organizationId ? ((_a = enterpriseByOrg.get(organizationId)) !== null && _a !== void 0 ? _a : false) : false; });
    useEffect(() => {
        if (!enabled || !organizationId)
            return;
        const cached = enterpriseByOrg.get(organizationId);
        if (cached !== undefined) {
            setIsEnterprise(cached);
            return;
        }
        let active = true;
        resolveIsEnterprise(organizationId).then((result) => {
            if (active)
                setIsEnterprise(result);
        });
        return () => {
            active = false;
        };
    }, [organizationId, enabled]);
    return isEnterprise;
};
